module.exports = __webpack_public_path__ + "static/media/logo-single.86f54ec0.png";